const Functions = {
  search: "https://europe-west1-code-identity-switcher.cloudfunctions.net/agentPortal/search",
  switch: "https://europe-west1-code-identity-switcher.cloudfunctions.net/agentPortal/switch"
};

export default Functions;